import { useMutation } from '@tanstack/react-query';

import { uploadFile } from '@api';

export const useUploadFileMutation = () => {
  return useMutation({ mutationFn: (file: File) => uploadFile(file) });
};
